import { z } from 'zod';

export const updateMonthlyCloseSchema = z.object({
  status: z
    .enum(['PROCESSING', 'READY_FOR_REVIEW', 'IN_REVIEW', 'APPROVED', 'DELIVERED'])
    .optional(),
  summary: z.string().optional(),
  reviewMinutes: z.number().min(0).optional(),
  // When signing off (status: APPROVED), the server rejects the transition if the
  // close still has unresolved flags or open blocking conversations. A reviewer can
  // consciously override that guard by sending force: true.
  force: z.boolean().optional(),
});

export const monthlyCloseQuerySchema = z.object({
  year: z.coerce.number().int().min(2020).max(2100),
  month: z.coerce.number().int().min(1).max(12),
});

export const statementUploadSchema = z.object({
  bankAccountId: z.string().optional(),
});
